<script setup lang="ts">
const route = useRoute()

const locationType = computed(() => {
  const routeName = route.name as string

  if (routeName?.startsWith('teamspace-workspaceId')) {
    return 'workspace'
  }

  if (routeName?.startsWith('repositories-gid')) {
    return 'repository'
  }

  if (routeName?.startsWith('teams-teamId')) {
    return 'team'
  }

  if (routeName?.startsWith('organization')) {
    return 'organization'
  }

  return null
})

const workspaceId = computed(() => {
  if (locationType.value === 'workspace') {
    return (route.params as { workspaceId: string }).workspaceId
  }
  return null
})

const repositoryGid = computed(() => {
  if (locationType.value === 'repository') {
    return (route.params as { gid: string }).gid
  }
  return null
})

const teamId = computed(() => {
  if (locationType.value === 'team') {
    return (route.params as { teamId: string }).teamId
  }
  return null
})
</script>

<template>
  <div v-if="locationType" class="flex flex-col">
    <div class="ml-4 py-1 text-sm font-medium text-gray-600 dark:text-gray-400">
      Current location
    </div>
    <NavigationCurrentLocationWorkspace v-if="locationType === 'workspace' && workspaceId" :workspace-id="workspaceId" />
    <NavigationCurrentLocationRepository v-if="locationType === 'repository' && repositoryGid" :repository-gid="repositoryGid" />
    <NavigationCurrentLocationTeam v-if="locationType === 'team' && teamId" :team-id="teamId" />
    <NavigationCurrentLocationOrganization v-if="locationType === 'organization'" />
  </div>
</template>
